<mat-form-field *ngIf="hasSearch && matTreeDataSource.data" class="mat-input-field">
  <input matInput placeholder="Search" (keyup.enter)="filter($event)" autocomplete="off">
</mat-form-field>
<div *ngIf="errorMessage" class="invalid-feedback" style="display: inline;margin-left: 20px;">{{errorMessage}}</div>

<div *ngIf="isBusy;else masterTree" style="padding: 15px;">
  <mat-spinner diameter="20" style="float:left"></mat-spinner>
  <span style="display: block;margin-left: 30px;font-size: 15px;">Searching...</span>
</div>

<ng-template #masterTree>
  <cdk-virtual-scroll-viewport *ngIf="isVirtualScroll; else default" itemSize="33" style="height: 400px;">
    <ng-container *cdkVirtualFor="let item of fullDataSource"></ng-container>
    <ng-container *ngTemplateOutlet="treeview"></ng-container>
  </cdk-virtual-scroll-viewport>

  <ng-template #default>
    <div [class.master-container]="!fromSummary">
      <ng-container *ngTemplateOutlet="treeview"></ng-container>
    </div>
  </ng-template>
</ng-template>

<ng-template #treeview>
  <mat-tree [dataSource]="matTreeDataSource" [treeControl]="treeControl" class="master-tree-container">
    <mat-nested-tree-node *matTreeNodeDef="let node" matTreeNodeToggle class="master-tree no-child">
      <li>
        <div class="mat-tree-node" [class.disabled]="node.isDisabled">
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node" *ngIf="hasCheckbox; else normal" [checked]="node.isSelected" (change)="onChangeNode(node)" [disabled]="node.isDisabled" [indeterminate]="node.indeterminate">
            <span class="node-ck-container" [class.selected]="node.isSelected">
              <span [ngClass]="{'node-items' :true, 'empty' : node.title == 'Empty'}" [innerHTML]="node.title | highlightSearch: currentTerm"></span>
            </span>
          </mat-checkbox>
          <ng-template #normal>
            <span class="node-container" [class.selected]="node.isSelected" (click)="emit(node)" [title]="node.title">
              <span [ngStyle]="{'pointer-events': viewMode ? 'none' : 'all'}" [ngClass]="{'node-items' :true, 'empty' : node.title == 'Empty'}" [innerHTML]="node.title | highlightSearch: currentTerm"></span>
            </span>
          </ng-template>
        </div>
      </li>
      <div *ngIf="node.hasLoadMore" style="width: 100%;text-align: center;">
        <button type="button" class="btn btn-primary btn-load-more" (click)="loadMore(node)">
          Load more...
        </button>
      </div>
    </mat-nested-tree-node>
  
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChildren" class="master-tree">
      <li class="tree-has-children">
        <div class="mat-tree-node" [class.disabled]="node.isDisabled">
          <button type="button" *ngIf="!node.isLoading" mat-icon-button matTreeNodeToggle (click)="toggleNode(treeControl.isExpanded(node), node, $event)" (keyup.enter)="enter($event, node);">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <div *ngIf="node.isLoading" class="isLoading">
            <img width="15" height="15" src='../../assets/images/lazyload_small.gif'>
          </div>
          <mat-checkbox class="checklist-leaf-node" *ngIf="hasCheckbox; else normal" [checked]="node.isSelected" (change)="onChangeNode(node)" [disabled]="node.isDisabled" [indeterminate]="node.indeterminate">
            <span class="node-ck-container" [class.selected]="node.isSelected">
              <span class="node-items" [innerHTML]="node.title | highlightSearch: currentTerm"></span>
            </span>
          </mat-checkbox>
          <ng-template #normal>
            <span class="node-container" [class.selected]="node.isSelected" (click)="emit(node)" [title]="node.title">
              <span [ngStyle]="{'pointer-events': viewMode ? 'none' : 'all'}" class="node-items" [innerHTML]="node.title | highlightSearch: currentTerm"></span>
            </span>
          </ng-template>
        </div>
        <ul>
          <div *ngIf="treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </ul>
      </li>
      <div *ngIf="node.hasLoadMore" style="width: 100%;text-align: center;">
        <button type="button" class="btn btn-primary btn-load-more" (click)="loadMore(node)">
          Load more...
        </button>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
</ng-template>